import { createContext, useContext, useMemo, useState } from "react";
import { CustomDateUtils } from "../../../../utils/CustomDateUtils";
import moment from "moment";

const SettingVariablesValueContext = createContext();
const SettingVariablesActionsContext = createContext();

export function SettingVariablesContextProvider({ children }) {
    const releaseToMoment = moment()
    const releaseFromMoment = moment(releaseToMoment).subtract(29, 'days');

    const [settingVariables, setSettingVariables] = useState({
        releaseFrom: CustomDateUtils().dateToYYYYMMDD(releaseFromMoment),
        releaseTo: CustomDateUtils().dateToYYYYMMDD(releaseToMoment),
        productCategoryIds: [],
        targetDOS: 14, // DOS is Days of Supply, 목표 재고소진 기간
        daysOfLeadTime: 14,
        searchCondition: 'PRODUCT_NAME',
        searchQuery: '',
        viewOnlyUnderLeadTimeFlag: false,
        hideNoOrderFlag: false,
        // IQR V3 이상치 판정 배수 (V3 탭에서만 사용)
        orderQtyMultiplier: 5,
        highQuantileMultiplier: 2,
        dailyRateMultiplier: 2,
    });

    const settingVariablesActions = useMemo(
        () => {
            return {
                onSet(newValues) {
                    setSettingVariables(newValues);
                },
                setValue: setSettingVariables
            }
        },
        []
    )

    return (
        <>
            <SettingVariablesActionsContext.Provider value={{ settingVariables: settingVariablesActions }}>
                <SettingVariablesValueContext.Provider value={{ settingVariables }}>
                    {children}
                </SettingVariablesValueContext.Provider>
            </SettingVariablesActionsContext.Provider>
        </>
    );
}

export function useSettingVariablesValueContextHook(props) {
    const value = useContext(SettingVariablesValueContext);

    if (value === undefined) {
        throw new Error('useSettingVariablesValueContextHook should be used within SettingVariablesValueContext');
    }

    return {
        settingVariables: value.settingVariables,
    };
}

export function useSettingVariablesActionsContextHook(props) {
    const value = useContext(SettingVariablesActionsContext);

    if (value === undefined) {
        throw new Error('useSettingVariablesActionsContextHook should be used within SettingVariablesActionsContext');
    }

    return {
        settingVariables: {
            onSet: value.settingVariables.onSet,
            setValue: value.settingVariables.setValue
        },
    };
}